export const layout = {
  pageMaxWidth: 1440,
};

export const siteUrl = 'https://www.shadesoflight.com';
